export enum CrmRequestsRoutes {
    Root = "/mis-solicitudes",
}
